module.exports = __webpack_public_path__ + "img/4.c10a55b6.png";